import React from 'react'

import { FirstStepChooseType } from './ChooseType'

export default function NewAction(props) {
  return <FirstStepChooseType />
}
